export default {"src":"/_next/static/media/iost.4d3105cf.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};